/**
 * Icon scale.
 *
 * Foundation-level steps with no product meaning, matching the `--rds-icon-*`
 * custom properties one-to-one. CSS consumes the custom property; JSX consumes
 * this map, because lucide takes `size` as a number rather than a length.
 *
 * Steps mirror the type scale so an icon can sit beside text of the same step:
 * xxs pairs with Overline, xs with Control and Body small, sm with Body,
 * md with Heading small, lg with Heading medium, xl with Title.
 */
export const ICON_SIZE = Object.freeze({
  xxs: 12,
  xs: 14,
  sm: 16,
  md: 18,
  lg: 20,
  xl: 24,
  xxl: 32,
});

/**
 * Shell stroke weight. Applied globally to `.lucide` in `index.css`, so icons
 * never need to pass it. Exported for the rare consumer that renders a
 * non-lucide glyph and has to match the surrounding weight by hand.
 */
export const ICON_STROKE = 1.5;
